import React, { useContext, useEffect, useState, useRef } from "react";
import SidebarContext from "../../contexts/MyContext";
import MyRecording from "../RecordingFeatures/MyRecording";
import NewRecording from "../RecordingFeatures/NewRecording";
import MergeRecordingPage from "../RecordingFeatures/MergeRecording";
import ConvertRecordingPage from "../RecordingFeatures/ConvertRecording";
import TranscriptRecordingPage from "../RecordingFeatures/TranscriptRecording";
import TrimRecordingPage from "../RecordingFeatures/TrimRecording";
import AdjustRecordingPage from "../RecordingFeatures/AdjustRecording";
import TranslateTextPage from "../RecordingFeatures/TranslateText";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import AudioList from "../../components/audioList/audioList";
import Record from "../RecordingFeatures/Record";
import AiTools from "../AiTools/AiTools";
import { generateRandomNumber } from "../../utils/generateRandomNumber";
import { errorToast, successToast } from "../../utils/notificationUtils";
import { formatTimeInHHMMSS } from "../../utils/timeFile";
import { truncateFileName } from "../../utils/truncateFileName";
import { convertToCaf, convertToM4a, convertToMp3, convertToWav } from "../RecordingFeatures/convertToMp3";
import '../../css/dashboard.css'

const Dashboard = () => {
  const { tabIndex, setTabIndex, setOpenFolderCreateModal, folders, setFolders,
    setFilterAudioData, setFavoriteAudio,
    selectedFolderAudioId, setSelectedFolderAudioId, setListTabIndex,
    actionTabIndex, setActionTabIndex, setAudio, recordNew, setRecordNew,
    selectedFormat, user, storeUser, audioListRefreshKey
  } = useContext(SidebarContext);
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [audioName, setAudioName] = useState("")
  const [isRecording, setIsRecording] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const intervalRef = useRef(null);
  const elapsedTimeRef = useRef(0);
  const [btntoggl, setBtnToggl] = useState(false)
  const [load, setLoading] = useState(false)
  const [note, setNote] = useState("")
  // Bumped by the AI Tools tab so clicking it again goes back to the tools grid.
  const [aiToolsKey, setAiToolsKey] = useState(0)
  const navigate = useNavigate()
  const location = useLocation();

  const shouldUploadRef = useRef(true);
  // Only the newest list request may write to state, so a slower earlier one cannot undo it.
  const audioListRequestRef = useRef(0);
  const mediaStreamRef = useRef(null);
  // The upload runs inside the recorder's onstop closure, so the note is mirrored in a ref.
  const noteRef = useRef("");



  const handleNoteChange = (text) => {
    noteRef.current = text;
    setNote(text);
  };

  const clearNote = () => {
    noteRef.current = "";
    setNote("");
  };

  const handleToggleSidebar = (e) => {
    setIsCollapsed(!isCollapsed)
  }



  const handleGetFilterAudioRecording = async (e, id) => {
    // e.stopPropagation()
    const requestId = ++audioListRequestRef.current;
    try {
      const { data } = await AudioHandler.doGetFilterRecording(id);
      if (requestId !== audioListRequestRef.current) {
        return;
      }
      setFilterAudioData(data?.audio)
      setFolders(data?.folders)

      const existingUser = JSON.parse(localStorage.getItem("currentUser")) || {};

      const userWithSubscription = {
        ...existingUser,
        isSubscriptionActive: data?.isSubscriptionActive,
        hasSubscribe: data?.hasSubscribe
      };

      storeUser(JSON.stringify(userWithSubscription));

      const favoriteAudioResponse = data?.audio?.filter(
        (item) => item?.isFavourite === true
      );

      setFavoriteAudio(favoriteAudioResponse)

      const matchingFolder = data?.folders?.find(folder => folder._id === id);

      if (matchingFolder) {
        setSelectedFolderAudioId(matchingFolder)
      }


    } catch (error) {
      console.error("error to fetch data", error);
    }
  };



  const handleCreateFolderClick = () => {
    setOpenFolderCreateModal(true); // Open the modal only when needed
  };

  const startRecording = async () => {


    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaStreamRef.current = stream;
      mediaRecorderRef.current = new MediaRecorder(stream, { mimeType: "audio/mp4" });

      audioChunksRef.current = []; // Reset audio chunks at the start of recording

      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.onstop = async () => {

        if (mediaStreamRef.current) {
          mediaStreamRef.current.getTracks().forEach((track) => track.stop());
          mediaStreamRef.current = null; // Clear the MediaStream
        }
        // Check the flag to determine if upload should be skipped
        if (!shouldUploadRef.current) {
          shouldUploadRef.current = true; // Reset flag for the next recording
          return; // Skip upload
        }

        if (audioChunksRef.current.length === 0) {
          console.error("No audio chunks available for creating audio blob.");
          return;
        }

        try {
          const audioBlob = new Blob(audioChunksRef.current, { type: "audio/mp4" });
          audioChunksRef.current = [];

          let processedBlob;
          try {
            if (selectedFormat === "mp3") {
              processedBlob = await convertToMp3(audioBlob);
            } else if (selectedFormat === "wav") {
              processedBlob = await convertToWav(audioBlob);
            } else if (selectedFormat === "caf") {
              processedBlob = await convertToCaf(audioBlob);
            } else if (selectedFormat === "m4a") {
              processedBlob = audioBlob; // Use raw blob for m4a
            } else {
              throw new Error("Unsupported audio format");
            }

            const randomAudioName = `Voice${generateRandomNumber()}`;
            setAudioName(randomAudioName);

            await doHandalUploadAudioUrl(processedBlob, randomAudioName, elapsedTimeRef.current);
          } catch (conversionError) {
            console.error("Audio conversion error:", conversionError);
          }
        } catch (blobError) {
          console.error("Error creating audio blob:", blobError);
        } finally {
          clearInterval(intervalRef.current);
          elapsedTimeRef.current = 0;
          setElapsedTime(0);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
      elapsedTimeRef.current = 0;


      intervalRef.current = setInterval(() => {
        elapsedTimeRef.current += 1; // Increment elapsed time
        setElapsedTime(elapsedTimeRef.current);


        if (elapsedTimeRef.current >= 300) {
          if (user?.isSubscriptionActive) {
            // Handle subscription logic
            if (mediaRecorderRef.current.state === "paused") {
              mediaRecorderRef.current.resume();
            }
            setIsRecording(true);
            setIsPaused(false);
          } else {
            // Pause and redirect if not subscribed
            mediaRecorderRef.current.pause();
            stopRecording();
            setIsRecording(false);
            setIsPaused(true);
            clearInterval(intervalRef.current);
            navigate("/pricing");
          }
        }
      }, 1000);
      // Use 1-second interval for accurate tracking
    } catch (err) {
      console.error("Failed to start recording", err);
      setIsRecording(false);
      setIsPaused(false);
    }
  };


  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      clearInterval(intervalRef.current);
      setElapsedTime(elapsedTimeRef.current);
    }
  };

  const pauseRecording = () => {
    if (mediaRecorderRef.current) {
      if (mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.pause();
        setIsPaused(true);
        clearInterval(intervalRef.current); // Stop incrementing elapsed time

      } else if (mediaRecorderRef.current.state === 'paused') {
        mediaRecorderRef.current.resume();
        setIsPaused(false);
        intervalRef.current = setInterval(() => {
          elapsedTimeRef.current += 1;
          setElapsedTime(elapsedTimeRef.current);
        }, 1000);
      }
    }
  };

  const resetRecording = () => {
    if (mediaRecorderRef.current) {
      shouldUploadRef.current = false; // Prevent upload on reset
      mediaRecorderRef.current.stop(); // Triggers the `onstop` event
      mediaRecorderRef.current = null; // Clear the MediaRecorder
    }

    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop());
      mediaStreamRef.current = null; // Clear the MediaStream
    }

    setIsRecording(false);
    setRecordNew(false)
    clearNote();
    clearInterval(intervalRef.current); // Stop the timer
    // setElapsedTime(0); // Reset the elapsed time
    // elapsedTimeRef.current = 0; // Reset the reference for elapsed time
  };

  const doHandalUploadAudioUrl = async (audioBlob, audioName, elapsedTime) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('audiofile', audioBlob, `${audioName}.${selectedFormat}`);
      formData.append('timeDuration', formatTimeInHHMMSS(elapsedTime));
      formData.append('action', 'Audio');
      formData.append('isFavourite', false);
      const noteContent = noteRef.current.trim();
      formData.append('hasnote', noteContent ? 'true' : 'false');
      if (noteContent) {
        formData.append('note', noteContent);
      }
      // Check if tabIndex matches el._id, and append folderId if necessary
      let folderId = null;
      if (tabIndex == selectedFolderAudioId?._id) {
        folderId = selectedFolderAudioId?._id; // Assign folderId to el._id if condition is met
      }

      const data = await AudioHandler.doUploadAudioUrl(formData, folderId);
      if (data?.statusCode === 200) {
        successToast(data?.message);
        setFilterAudioData((prevFilterAudioData) => [
          data?.data,
          ...prevFilterAudioData,
        ]);
        setRecordNew(false)
        setElapsedTime(0); // Reset the elapsed time
        elapsedTimeRef.current = 0;
        clearNote();
        if (user && user?.isSubscriptionActive) {
          setTabIndex(folderId ? folderId : 2);
        }

        setBtnToggl(false)
      } else {
        const errorMessage =
          data?.response?.data?.error ||
          data?.response?.data?.message ||
          data.message ||
          "An error occurred";
        errorToast(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "An error occurred";
      errorToast(errorMessage);
      setBtnToggl(false)

    } finally {
      setLoading(false);
      setBtnToggl(false)

    }
  };

  useEffect(() => {

    // Only folder tabs carry an id; 1, 2 and 3 are fixed tabs and must not be sent as one.
    if (tabIndex != "1" && tabIndex != "2" && tabIndex != "3") {
      handleGetFilterAudioRecording(null, tabIndex);
    } else {
      handleGetFilterAudioRecording();
    }

    // after remove setSelectedFpormat stop multiple time api call
    // setSelectedFormat(user?.audioFormat)
  }, [tabIndex, selectedFormat, audioListRefreshKey]);

  useEffect(() => {
    return () => {
      resetRecording();
    };
  }, [tabIndex]);






  return (
    <div className="vr-shell">
      <aside className={`vr-rail${isCollapsed ? " is-open" : ""}`}>
        <nav className="vr-rail-nav" aria-label="Dashboard">
          <div
            role="button"
            tabIndex={0}
            className={`vr-rail-item${tabIndex == 1 ? " is-active" : ""}`}
            aria-current={tabIndex == 1 ? "page" : undefined}
            title="Record new"
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.currentTarget.click(); } }}
            onClick={() => {
              {
                setTabIndex(1); setAudio(); setActionTabIndex(null); setRecordNew(false); resetRecording(); setElapsedTime(0);
                elapsedTimeRef.current = 0;
              }
            }}
          >
            <Icon icon="lucide:mic" className="vr-rail-icon" />
            <p className="vr-rail-label">
              {isCollapsed ? "Record new" : ''}
            </p>
          </div>
          <div
            role="button"
            tabIndex={0}
            className={`vr-rail-item${tabIndex == 3 ? " is-active" : ""}`}
            aria-current={tabIndex == 3 ? "page" : undefined}
            title="Ai tools"
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.currentTarget.click(); } }}
            onClick={() => {
              setTabIndex(3); setAiToolsKey((key) => key + 1); setAudio(); setActionTabIndex(null); setRecordNew(false); resetRecording(); setElapsedTime(0);
              setBtnToggl(false);
              elapsedTimeRef.current = 0;
            }}
          >
            <Icon icon="lucide:sparkles" className="vr-rail-icon" />
            <p className="vr-rail-label">
              {isCollapsed ? "Ai tools" : ''}
            </p>
            {/* Flags the tab as new: a pill beside the label, or a dot-pill over the icon when the rail is narrow. */}
            <span className={`ai-tools-new-badge vr-new-badge${isCollapsed ? "" : " is-floating"}`}>
              New
            </span>
          </div>
          <div
            role="button"
            tabIndex={0}
            className={`vr-rail-item${tabIndex == 2 ? " is-active" : ""}`}
            aria-current={tabIndex == 2 ? "page" : undefined}
            title="My Recordings"
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.currentTarget.click(); } }}
            onClick={(e) => {
              // setTabIndex(2);
              setTabIndex((prevTabIndex) => {
                if (prevTabIndex != 2) {
                  // resetRecording();
                }
                return 2;
              });
              setAudio(); setActionTabIndex(null); handleGetFilterAudioRecording(e); setRecordNew(false);
              setBtnToggl(false)
              resetRecording();
              setElapsedTime(0);
              elapsedTimeRef.current = 0;

            }}
          >
            <Icon icon="lucide:audio-lines" className="vr-rail-icon" />
            <p className="vr-rail-label">
              {isCollapsed ? "My Recordings" : ''}
            </p>
          </div>

          {folders?.filter((el) => !el.isDeleted).length > 0 && <div className="vr-rail-sep" />}

          {folders?.filter((el) => !el.isDeleted).map((el, i) => {

            return (
              <div
                key={i}
                role="button"
                tabIndex={0}
                className={`vr-rail-item${tabIndex === el._id ? " is-active" : ""}`}
                title={el?.name}
                aria-current={tabIndex === el._id ? "page" : undefined}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.currentTarget.click(); } }}
                onClick={(e) => {
                  // setTabIndex(el._id);
                  setTabIndex((prevTabIndex) => {
                    // console.log(prevTabIndex, '')
                    if (prevTabIndex != el._id) {
                      // resetRecording();
                    }
                    return el._id;
                  });
                  setSelectedFolderAudioId(el); setListTabIndex(1); handleGetFilterAudioRecording(e, el?._id); setActionTabIndex(null); setAudio(); setRecordNew(false);
                  setBtnToggl(false)
                  resetRecording();
                  setElapsedTime(0);
                  elapsedTimeRef.current = 0;


                }}
              >
                {/* Folder icon carrying the folder's first letter */}
                <svg xmlns="http://www.w3.org/2000/svg"
                  width="2em"
                  height="2em"
                  viewBox="0 0 24 24"
                  className="vr-rail-icon"
                >
                  <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                  <text
                    x="50%"
                    y="60%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fill="currentColor"
                    fontSize="9px"
                    fontWeight="bold"
                  >
                    {el?.name?.charAt(0)}
                  </text>
                </svg>

                {/* Folder Name */}
                <p className="vr-rail-label" title={el?.name}>
                  {el?.name}
                </p>
              </div>
            );
          })}


        </nav>
        <div className="vr-rail-foot">
          {!(tabIndex == 1 || tabIndex == 3) && (
            <div
              role="button"
              tabIndex={0}
              className="vr-rail-create"
              title="Create Folder"
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.currentTarget.click(); } }}
              onClick={(e) => {
                // e.stopPropagation(); 
                handleCreateFolderClick();
              }}

            >
              <Icon icon="lucide:folder-plus" className="vr-rail-icon" />
              {isCollapsed ? (
                <span className="vr-rail-label" title={"Create Folder"}>
                  Create Folder
                </span>
              ) : ''}
            </div>
          )}
          <button
            type="button"
            className="vr-rail-toggle"
            aria-label={isCollapsed ? "Collapse sidebar" : "Expand sidebar"}
            aria-expanded={isCollapsed}
            title={isCollapsed ? "Collapse sidebar" : "Expand sidebar"}
            onClick={(e) => handleToggleSidebar(e)}
          >
            <Icon icon={isCollapsed ? "lucide:chevrons-left" : "lucide:chevrons-right"} aria-hidden="true" />
          </button>
        </div>
      </aside>

      <div className={`vr-listcol${(tabIndex == 1 || tabIndex == 3) ? " is-hidden" : ""}`}>
        <AudioList startRecording={startRecording} elapsedTime={elapsedTime} />
      </div>
      <div
        className={`vr-maincol${(tabIndex == 1 || tabIndex == 3) && !actionTabIndex && !recordNew ? " is-scroll" : ""}`}
      >
        {!actionTabIndex && (
          <>
            {recordNew ? <Record elapsedTime={elapsedTime} btntoggl={btntoggl} setBtnToggl={setBtnToggl} pauseRecording={pauseRecording} stopRecording={stopRecording} load={load} setLoading={setLoading} note={note} onNoteChange={handleNoteChange} /> : (
              <>
                {tabIndex != 1 && tabIndex != 2 && tabIndex != 3 && actionTabIndex != 3 && actionTabIndex != 4 && actionTabIndex != 5 && actionTabIndex != 6 && <MyRecording startRecording={startRecording} elapsedTime={elapsedTime} />}
                {tabIndex == 1 && <NewRecording />}
                {tabIndex == 3 && <AiTools key={aiToolsKey} />}
                {tabIndex == 2 && <MyRecording startRecording={startRecording} elapsedTime={elapsedTime} />}
              </>
            )}
          </>
        )}
        {actionTabIndex == 3 && <TrimRecordingPage />}
        {actionTabIndex == 4 && <MergeRecordingPage />}
        {actionTabIndex == 5 && <ConvertRecordingPage />}
        {actionTabIndex == 6 && <TranscriptRecordingPage />}
        {actionTabIndex == 7 && <AdjustRecordingPage />}
        {actionTabIndex == 8 && <TranslateTextPage />}

      </div>
    </div>
  );
};

export default Dashboard;
